import { LegacyTokenResponse } from '@vis-auth/legacy';

/* eslint-disable @typescript-eslint/camelcase */
const eveOauth2Token: LegacyTokenResponse = {
  access_token: 'mock_eve_oauth2_provider_access_token',
  token_type: 'Bearer',
  expires_in: 7200,
  refresh_token: 'mock_eve_oauth2_provider_refresh_token',
  created_at: 1611613510,
};

export default eveOauth2Token;
